import { render, staticRenderFns } from "./rateindex.vue?vue&type=template&id=53386b4b&scoped=true&"
import script from "./rateindex.vue?vue&type=script&lang=js&"
export * from "./rateindex.vue?vue&type=script&lang=js&"
import style0 from "./rateindex.vue?vue&type=style&index=0&id=53386b4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53386b4b",
  null
  
)

export default component.exports